import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs";
import TermsAndConditionsService from "../../../services/terms-and-conditions-service";
import { TermsAndConditions } from "../../../models";
import TermsAndConditionsForm from "./ui/terms-and-conditions-form";
import TermsAndConditionsSkeleton from "./skeletons/terms-and-conditions-skeleton";

export default function TermsAndConditionsPage() {
  const [searchParams] = useSearchParams();
  const [termsAndConditions, setTermsAndConditions] =
    useState<TermsAndConditions | null>(null);
  const [loading, setLoading] = useState(true);
  const termsAndConditionsService = new TermsAndConditionsService();

  useEffect(() => {
    fetchTermsAndConditions();
  }, [searchParams.get("reload")]);

  const fetchTermsAndConditions = async () => {
    setLoading(true);
    try {
      const result = await termsAndConditionsService.getTermsAndConditions();
      setTermsAndConditions(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          {
            label: "Terms and Conditions",
            href: "/admin/terms-and-conditions",
          },
        ]}
      />
      
      {loading ? (
        <TermsAndConditionsSkeleton />
      ) : (
        <TermsAndConditionsForm
          key={termsAndConditions?.updatedAt ?? "new"}
          termsAndConditions={termsAndConditions}
        />
      )}
    </main>
  );
}
